// extracted by mini-css-extract-plugin
export default {"note":"fit-score-history-note_note__b2iX6"};